import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DigitOnlyModule } from '@uiowa/digit-only';
import { Angular2SignaturepadModule } from 'angular2-signaturepad';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { DisplayModule } from 'src/app/shared/display/display.module';
import { InputsDirectiveModule } from 'src/app/shared/inputs-directive/inputs-directive.module';

import { ChooseInsurancePlanComponent } from './choose-insurance-plan/choose-insurance-plan.component';
import { InputAddressModalComponent } from './input-address-modal/input-address-modal.component';
import { InputAddressPostcodeComponent } from './input-address-postcode/input-address-postcode.component';
import { InputAddressComponent } from './input-address/input-address.component';
import { InputBuyforComponent } from './input-buyfor/input-buyfor.component';
import { InputCheckboxComponent } from './input-checkbox/input-checkbox.component';
import { InputCitizenIdWithDateComponent } from './input-citizen-id-with-date/input-citizen-id-with-date.component';
import { InputCitizenIdComponent } from './input-citizen-id/input-citizen-id.component';
import { InputDpAddressTypeComponent } from './input-dp-address-type/input-dp-address-type.component';
import { InputDpDistrictComponent } from './input-dp-district/input-dp-district.component';
import { InputDpLocaleComponent } from './input-dp-locale/input-dp-locale.component';
import { InputDpNationalityComponent } from './input-dp-nationality/input-dp-nationality.component';
import { InputDpOccupationComponent } from './input-dp-occupation/input-dp-occupation.component';
import { InputDpProvinceComponent } from './input-dp-province/input-dp-province.component';
import { InputDpRelationshipComponent } from './input-dp-relationship/input-dp-relationship.component';
import { InputDpSubdistrictComponent } from './input-dp-subdistrict/input-dp-subdistrict.component';
import { InputDpTitleNameComponent } from './input-dp-title-name/input-dp-title-name.component';
import { InputDrawLicenseComponent } from './input-draw-license/input-draw-license.component';
import { ModalContentDrawLicenseComponent } from './input-draw-license/modal-content-draw-license.component';
import { InputEmailTypeaheadComponent } from './input-email-typeahead/input-email-typeahead.component';
import { InputGenderComponent } from './input-gender/input-gender.component';
import { InputGroupSearchComponent } from './input-group-search/input-group-search.component';
import { InputInsurancePayerComponent } from './input-insurance-payer/input-insurance-payer.component';
import { InputInsuranceTypeComponent } from './input-insurance-type/input-insurance-type.component';
import { InputRadioCheckMarkComponent } from './input-radio-check-mark/input-radio-check-mark.component';
import { InputRadioMaritalStatusComponent } from './input-radio-marital-status/input-radio-marital-status.component';
import { InputRadioPremiumPaymentComponent } from './input-radio-premium-payment/input-radio-premium-payment.component';
import { InputTextDateComponent } from './input-text-date/input-text-date.component';
import { InputTextGroupComponent } from './input-text-group/input-text-group.component';
import { InputTextComponent } from './input-text/input-text.component';
import { InputPhoneNumberComponent } from './input-phone-number/input-phone-number.component';
import { InputDpFamilyTypeComponent } from './input-dp-family-type/input-dp-family-type.component';
import { InputGenderQqComponent } from './input-gender-qq/input-gender-qq.component';
import { InputDpOccupationClassComponent } from './input-dp-occupation-class/input-dp-occupation-class.component';
import { InputDpRidersFixedComponent } from './input-dp-riders-fixed/input-dp-riders-fixed.component';
import { InputDatepickerComponent } from './input-datepicker/input-datepicker.component';
import { MatFormFieldModule, MatInputModule, MatDatepickerModule, MatNativeDateModule, MAT_DATE_LOCALE, MAT_DATE_FORMATS, DateAdapter } from '@angular/material';
import { AppDateAdapter, APP_DATE_FORMATS } from 'src/app/config/date.adapter';
import { NgxMaskModule } from 'ngx-mask';
import { TextMaskModule } from 'angular2-text-mask';
import { InputDpTaxRateComponent } from './input-dp-tax-rate/input-dp-tax-rate.component';
import { PreviewProspectComponent } from './preview-prospect/preview-prospect.component';

@NgModule({
  declarations: [
    InputTextComponent,
    InputDpLocaleComponent,
    InputTextDateComponent,
    InputGenderComponent,
    InputDpProvinceComponent,
    InputInsuranceTypeComponent,
    InputGroupSearchComponent,
    ChooseInsurancePlanComponent,
    InputEmailTypeaheadComponent,
    InputDrawLicenseComponent,
    InputTextGroupComponent,
    InputBuyforComponent,
    InputDpRelationshipComponent,
    InputDpTitleNameComponent,
    ModalContentDrawLicenseComponent,
    InputDpAddressTypeComponent,
    InputAddressModalComponent,
    InputAddressPostcodeComponent,
    InputAddressComponent,
    InputDpSubdistrictComponent,
    InputDpDistrictComponent,
    InputDpNationalityComponent,
    InputCitizenIdComponent,
    InputCitizenIdWithDateComponent,
    InputRadioMaritalStatusComponent,
    InputRadioPremiumPaymentComponent,
    InputCheckboxComponent,
    InputDpOccupationComponent,
    InputRadioCheckMarkComponent,
    InputInsurancePayerComponent,
    InputPhoneNumberComponent,
    InputDpFamilyTypeComponent,
    InputGenderQqComponent,
    InputDpOccupationClassComponent,
    InputDpRidersFixedComponent,
    InputDatepickerComponent,
    InputDpTaxRateComponent,
    PreviewProspectComponent
  ],
  entryComponents: [
    ModalContentDrawLicenseComponent,
    InputAddressModalComponent,
    PreviewProspectComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    BsDropdownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TypeaheadModule.forRoot(),
    ModalModule.forRoot(),
    Angular2SignaturepadModule,
    InfiniteScrollModule,
    DisplayModule,
    InputsDirectiveModule,
    DigitOnlyModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    NgxMaskModule.forRoot(),
    TextMaskModule
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,

    InputTextComponent,
    InputDpLocaleComponent,
    InputTextDateComponent,
    InputGenderComponent,
    InputDpProvinceComponent,
    InputInsuranceTypeComponent,
    InputGroupSearchComponent,
    ChooseInsurancePlanComponent,
    InputEmailTypeaheadComponent,
    InputDrawLicenseComponent,
    InputTextGroupComponent,
    InputBuyforComponent,
    InputDpRelationshipComponent,
    InputDpTitleNameComponent,
    InputDpAddressTypeComponent,
    InputAddressModalComponent,
    InputDpSubdistrictComponent,
    InputDpDistrictComponent,
    InputDpNationalityComponent,
    InputCitizenIdComponent,
    InputCitizenIdWithDateComponent,
    InputRadioMaritalStatusComponent,
    InputRadioPremiumPaymentComponent,
    InputCheckboxComponent,
    InputDpOccupationComponent,
    InputRadioCheckMarkComponent,
    InputInsurancePayerComponent,
    InputAddressComponent,
    InputPhoneNumberComponent,
    InputDpFamilyTypeComponent,
    InputGenderQqComponent,
    InputDpOccupationClassComponent,
    InputDpRidersFixedComponent,
    InputDatepickerComponent,
    InputDpTaxRateComponent,
    PreviewProspectComponent
  ],
  providers: [
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
  ]
})
export class InputsModule {
}
